import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL; // http://localhost:5200/api_alo
const CODECLIENT = process.env.REACT_APP_CODE_CLIENT;
const SHAI = process.env.REACT_APP_SHAI;

// ✅ Récupérer tous les logos (admin)
export const getAllLogo = async (): Promise<any> => {
  try {
    const response = await axios.get(`${API_URL}/logo`);
    return response.data.logos;
  } catch (error) {
    console.error('Erreur lors de la récupération de tous les logos:', error);
    throw error;
  }
};

// ✅ Récupérer tous les logos d'un utilisateur spécifique
export const getAllLogosByUser = async (userId?: string): Promise<any> => {
  try {
    const user_id = userId || localStorage.getItem('userId') || '';
    const response = await axios.get(`${API_URL}/logo/user/${user_id}`);
    return response.data.logos;
  } catch (error) {
    console.error('Erreur lors de la récupération des logos:', error);
    throw error;
  }
};

// ✅ Ajouter un logo
export const addLogo = async (
  imageBase64: string,
  filename: string,
  sSHA1: string,
  codeClient: string,
  floId: string,
  logoLibele: string,
  logoInfo: string,
  logoNom: string
): Promise<any> => {
  try {
    const response = await axios.post(`${API_URL}/logo`, {
      image: imageBase64,
      filename,
      sSHA1: SHAI,
      codeClient: CODECLIENT,
      floId,
      logoLibele,
      logoInfo,
      logoNom,
      user_id: localStorage.getItem('userId') ?? ''
    });
    return response.data.file;
  } catch (error) {
    console.error("Erreur lors de l'ajout du logo:", error);
    throw error;
  }
};

// ✅ Supprimer un logo par ID
export const deleteLogo = async (id: number): Promise<void> => {
  try {
    await axios.delete(`${API_URL}/logo/${id}`);
  } catch (error: any) {
    console.error("Erreur lors de la suppression du logo:", error);
    throw new Error(
      error?.response?.data?.message || 
      error?.message || 
      'Erreur lors de la suppression du logo'
    );
  }
};

// ✅ Récupérer uniquement les logos acceptés de l'utilisateur
export const getAcceptedLogosByUser = async (): Promise<any[]> => {
  try {
    const user_id: string = localStorage.getItem('userId') ?? '';
    const response = await axios.get(`${API_URL}/logo/user/${user_id}`);
    return response.data.logos.filter((logo: any) => logo.logo_status === 'accepted');
  } catch (error) {
    console.error('Erreur lors de la récupération des logos acceptés:', error);
    return [];
  }
};

// ✅ Notification mail de suppression de logos
export const notifyLogoDeletion = async (
  email: string,
  userName: string,
  deletedCount: number,
  reason: string
): Promise<any> => {
  try {
    const response = await axios.post(`${API_URL}/logo/notify-logo-deletion`, {
      email,
      userName,
      deletedCount,
      reason
    });
    return response.data;
  } catch (error) {
    console.error('Erreur notification mail:', error);
    throw error;
  }
};